<template>

	<div class="content background1"  v-if="versions != 2">
		<div class="tableBox17" style="padding: 60px 0 0 0; height: 55%;;position: static; ">
			<div class="tableMes" style="background-color: #FFFFFF; margin: 10px 10px 0 10px;">
				<div class="table2 table3" style="width: 100%; height: calc(100% - 20px); margin: 10px 10px 0 10px; background-color:transparent;">
					<div class="dataBox">
						<div class="icon" style="width: 30%;">
							<div class="set" @click="toPath('/static/deviceFilePage')">{{$t('label_84')}}</div>
							<div class="ban" @click="toPath('/static/malfunctionResumePage')">{{$t('label_87')}}</div>
							<div class="search" @click="toPath('/static/maintainResumePage')">{{$t('label_90')}}</div>
							<div class="check" @click="toPath('/static/InspectionRecord')">{{$t('label_102')}}</div>
						</div>
						<div class="data" style="width: 70%;height: 98%">
							<el-calendar>
								<!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
								<template slot="dateCell" slot-scope="{date, data}">
									<p :class="data.isSelected ? 'is-selected' : ''">
										{{data.day.split('-')[2]}}
									</p>
									<div class="iconBox">
										<template v-for="item in list.dayList">
											<template v-if="item.time == data.day">
												<div class="icon ban" v-if="item.repairTime > 0"></div>
												<div class="icon search" v-if="item.maintainTime > 0"></div>
												<div class="icon check" v-if="item.inspTime > 0"></div>
											</template>
										</template>
									</div>
								</template>
							</el-calendar>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="tableBox17" style="padding: 0; height: calc(45% - 20px);position: static;top: unset;margin-top: 10px;">
			<div class="tableMes">
				<div class="table2" style="width: calc(50% - 5px)">
					<div class="title">{{$t('label_93')}}</div>
					<div class="statusList">
						<div class="mes" style="color: #fe0000">
							<p>{{$t('label_97')}}</p>
							<p style="font-size: 45px">{{list.red}}</p>
						</div>
						<div class="mes" style="color: #ffcc66">
							<p>{{$t('label_101')}}</p>
							<p style="font-size: 45px">{{list.yellow}}</p>
						</div>
						<div class="mes" style="color: #3fb393">
							<p>{{$t('label_105')}}</p>
							<p style="font-size: 45px">{{list.green}}</p>
						</div>
					</div>
				</div>
				<div class="table2" style="width: calc(50% - 5px)">
					<div class="title">{{$t('label_108')}}<span style="color: #aaaaaa">{{'（'}}{{$t('label_111')}}{{'）'}}</span></div>
					<div class="statusList2">
						<div class="mes">
							<p style="font-size: 40px; color: #fe0000;font-weight: bold">{{list.redNum}}</p>
							<p>{{$t('label_97')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #ffcc66;font-weight: bold">{{list.yellowNum}}</p>
							<p>{{$t('label_101')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #3fb393;font-weight: bold">{{list.greenNum}}</p>
							<p>{{$t('label_105')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #fe0000;font-weight: bold">{{list.redBuyNum}}</p>
							<p>{{$t('label_114')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #ffcc66;font-weight: bold">{{list.yellowBuyNum}}</p>
							<p>{{$t('label_117')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #3fb393;font-weight: bold">{{list.greenBuyNum}}</p>
							<p>{{$t('label_122')}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="content background1" v-else>
		<div class="tableBox16">
			<div class="tableMes">
				<div class="table">
					<div class="mainBg">
						<div class="jidian">
							<div class="set" @click="toPath('/static/deviceFilePage')" :class="list.faDevice > 2 ? 'red' : list.faDevice > 1 ? 'yellow' : 'green'"></div>
							<div class="ban" @click="toPath('/static/malfunctionResumePage')" :class="list.faRepair > 2 ? 'red' : list.faRepair > 1 ? 'yellow' : 'green'"></div>
							<div class="search" @click="toPath('/static/maintainResumePage')" :class="list.faMaintain > 2 ? 'red' : list.faMaintain > 1 ? 'yellow' : 'green'"></div>
							<div class="check" @click="toPath('/static/InspectionRecord')" :class="list.faInsp > 2 ? 'red' : list.faInsp > 1 ? 'yellow' : 'green'"></div>
						</div>
						<div class="fabu">
							<div class="set" :class="list.mechanoDevice > 2 ? 'red' : list.mechanoDevice > 1 ? 'yellow' : 'green'" @click="toPath('/static/deviceFilePage')"></div>
							<div class="ban" @click="toPath('/static/malfunctionResumePage')" :class="list.mechanoRepair > 2 ? 'red' : list.mechanoRepair > 1 ? 'yellow' : 'green'">
							</div>
							<div class="search" @click="toPath('/static/maintainResumePage')" :class="list.mechanoMaintain > 2 ? 'red' : list.mechanoMaintain > 1 ? 'yellow' : 'green'">
							</div>
							<div class="check" @click="toPath('/static/InspectionRecord')" :class="list.fmechanoInsp > 2 ? 'red' : list.mechanoInsp > 1 ? 'yellow' : 'green'">
							</div>
						</div>
						<div class="peidian">
							<div class="set" @click="toPath('/static/deviceFilePage')" :class="list.distDevice > 2 ? 'red' : list.distDevice > 1 ? 'yellow' : 'green'"></div>
							<div class="ban" @click="toPath('/static/malfunctionResumePage')" :class="list.distRepair > 2 ? 'red' : list.distRepair > 1 ? 'yellow' : 'green'"></div>
							<div class="search" @click="toPath('/static/maintainResumePage')" :class="list.distMaintain > 2 ? 'red' : list.distMaintain > 1 ? 'yellow' : 'green'">
							</div>
							<div class="check" @click="toPath('/static/InspectionRecord')" :class="list.distInsp > 2 ? 'red' : list.distInsp > 1 ? 'yellow' : 'green'"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="tableBox17">
			<div class="tableMes">
				<div class="table2" style="width: 25%">
					<div class="title">{{$t('label_93')}}</div>
					<div class="statusList">
						<div class="mes" style="color: #fe0000">
							<p>{{$t('label_97')}}</p>
							<p style="font-size: 45px">{{list.red}}</p>
						</div>
						<div class="mes" style="color: #ffcc66">
							<p>{{$t('label_101')}}</p>
							<p style="font-size: 45px">{{list.yellow}}</p>
						</div>
						<div class="mes" style="color: #3fb393">
							<p>{{$t('label_105')}}</p>
							<p style="font-size: 45px">{{list.green}}</p>
						</div>
					</div>
				</div>
				<div class="table2" style="width: 49%">
					<div class="dataBox">
						<div class="icon">
							<div class="set" @click="toPath('/static/deviceFilePage')">{{$t('label_84')}}</div>
							<div class="ban" @click="toPath('/static/malfunctionResumePage')">{{$t('label_87')}}</div>
							<div class="search" @click="toPath('/static/maintainResumePage')">{{$t('label_90')}}</div>
							<div class="check" @click="toPath('/static/InspectionRecord')">{{$t('label_102')}}</div>
						</div>
						<div class="data" style="width: 900px;height: 210px">
							<el-calendar>
								<!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
								<template slot="dateCell" slot-scope="{date, data}">
									<p :class="data.isSelected ? 'is-selected' : ''">
										{{data.day.split('-')[2]}}
									</p>
									<div class="iconBox">
										<template v-for="item in list.dayList">
											<template v-if="item.time == data.day">
												<div class="icon ban" v-if="item.repairTime > 0"></div>
												<div class="icon search" v-if="item.maintainTime > 0"></div>
												<div class="icon check" v-if="item.inspTime > 0"></div>
											</template>
										</template>
									</div>
								</template>
							</el-calendar>
						</div>
					</div>
				</div>
				<div class="table2" style="width: 25%">
					<div class="title">{{$t('label_108')}}<span style="color: #aaaaaa">{{'（'}}{{$t('label_111')}}{{'）'}}</span></div>
					<div class="statusList2">
						<div class="mes">
							<p style="font-size: 40px; color: #fe0000;font-weight: bold">{{list.redNum}}</p>
							<p>{{$t('label_97')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #ffcc66;font-weight: bold">{{list.yellowNum}}</p>
							<p>{{$t('label_101')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #3fb393;font-weight: bold">{{list.greenNum}}</p>
							<p>{{$t('label_105')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #fe0000;font-weight: bold">{{list.redBuyNum}}</p>
							<p>{{$t('label_114')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #ffcc66;font-weight: bold">{{list.yellowBuyNum}}</p>
							<p>{{$t('label_117')}}</p>
						</div>
						<div class="mes">
							<p style="font-size: 40px; color: #3fb393;font-weight: bold">{{list.greenBuyNum}}</p>
							<p>{{$t('label_122')}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import TimePage from "@/assets/js/timePage/timePage.js";
	import utils from '@/utils/utils'
	import calendar from "@/components/list/calendar/calendar";
	import file from "@/assets/js/file/file.js";
	import exportMes from "@/components/list/export/export";
	import common from "@/assets/js/common/common.js";

	export default {
		name: 'fileFactory',
		components: {
			Page,
			calendar,
			exportMes,
		},
		data() {
			return {
				list: [],
				day: '',
				versions: '',
			}
		},
		methods: {
			toPath(key) {
				test2(key)
			},
			homePage(param) {
				common.homePage(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.list = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			getPreMonth(date) {
				//判断日期常用格式的正则
				let regA = /^(\d{4})-(\d{1,2})-(\d{1,2})$/, //日期格式为：yyyy-mm-dd
					regB = /^(\d{4})年(\d{1,2})月(\d{1,2})日$/, //日期格式为：yyyy年mm月dd日
					regC = /^(\d{4})年-(\d{1,2})月-(\d{1,2})日$/, //日期格式为：yyyy年-mm月-dd日
					regD = /^(\d{4})(\d{2})(\d{2})$/, //日期格式为：yyyymmdd
					regE = /^(\d{4})-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/, //日期格式为：yyyy-mm-dd hh:mm:ss
					regF = /^(\d{4})年(\d{1,2})月(\d{1,2})日 (\d{1,2}):(\d{1,2}):(\d{1,2})$/, //日期格式为：yyyy年mm月dd日 hh:mm:ss
					regG = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/; //日期格式为：yyyymmddhhmmss
				//判断传入的日期进行正则表达式匹配
				let arr = [];
				switch (true) {
					case regA.test(date):
					case regB.test(date):
					case regC.test(date):
					case regD.test(date):
						arr.push(RegExp.$1, RegExp.$2, RegExp.$3); //RegExp.$1获取匹配到的第一个值匹配，即‘2022’，以此类推
						console.log(arr, "arr");
						break;
					case regE.test(date):
					case regF.test(date):
					case regG.test(date):
						arr.push(
							RegExp.$1,
							RegExp.$2,
							RegExp.$3,
							RegExp.$4,
							RegExp.$5,
							RegExp.$6
						);
						console.log(arr, "arr");
						break;

					default:
						console.log("没有满足的日期格式");
						return;
				}

				arr = [...arr];
				let [year, month, day, hour, minute, second] = arr;

				let newYear = year,
					newDay = day,
					newMonth = parseInt(month) - 1;
				if (newMonth == 0) {
					newYear = parseInt(newYear) - 1;
					newMonth = 12;
				}
				let lastDays = new Date(newYear, newMonth, 0);
				lastDays = lastDays.getDate();

				newDay = newDay > lastDays ? lastDays : newDay;

				newMonth =
					newMonth < 10 && String(newMonth).length < 2 ? "0" + newMonth : newMonth;
				newDay = newDay < 10 && newDay.length < 2 ? "0" + newDay : newDay;
				minute = minute < 10 && minute.length < 2 ? "0" + minute : minute;
				second = second < 10 && second.length < 2 ? "0" + second : second;

				return arr.length > 3 ?
					`${newYear}-${newMonth}-${newDay} ${hour}:${minute}:${second}` :
					`${newYear}-${newMonth}-${newDay}`;
			},
			getNextMonth(date) {
				//判断日期常用格式的正则
				let regObj = {
						regA: /^(\d{4})-(\d{1,2})-(\d{1,2})$/, //日期格式为：yyyy-mm-dd
						regB: /^(\d{4})年(\d{1,2})月(\d{1,2})日$/, //日期格式为：yyyy年mm月dd日
						regC: /^(\d{4})年-(\d{1,2})月-(\d{1,2})日$/, //日期格式为：yyyy年-mm月-dd日
						regD: /^(\d{4})(\d{2})(\d{2})$/, //日期格式为：yyyymmdd
					},
					regObj2 = {
						regE: /^(\d{4})-(\d{1,2})-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/, //日期格式为：yyyy-mm-dd hh:mm:ss
						regF: /^(\d{4})年(\d{1,2})月(\d{1,2})日 (\d{1,2}):(\d{1,2}):(\d{1,2})$/, //日期格式为：yyyy年mm月dd日 hh:mm:ss
						regG: /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/, //日期格式为：yyyymmddhhmmss
					};

				//判断传入的日期进行正则表达式匹配
				let arr = [],
					valArr = [];
				//调用日期正则匹配公共方法
				if (this.dateRegexFun(date, regObj)) {
					valArr = this.dateRegexFun(date, regObj);
					arr.push(valArr[1], valArr[2], valArr[3]);
				}
				//调用日期正则匹配公共方法
				if (this.dateRegexFun(date, regObj2)) {
					valArr = this.dateRegexFun(date, regObj2);
					arr.push(valArr[1], valArr[2], valArr[3], valArr[4], valArr[5], valArr[6]);
				}

				if (arr.length === 0) return;
				arr = [...arr];
				let [year, month, day, hour, minute, second] = arr;

				let newYear = year,
					newDay = day,
					newMonth = parseInt(month) + 1;
				if (newMonth == 13) {
					newYear = parseInt(newYear) + 1;
					newMonth = 1;
				}
				let nextDays = new Date(newYear, newMonth, 0);
				nextDays = nextDays.getDate();

				newDay = newDay > nextDays ? nextDays : newDay;
				newMonth =
					newMonth < 10 && String(newMonth).length < 2 ? "0" + newMonth : newMonth;
				newDay = newDay < 10 && newDay.length < 2 ? "0" + newDay : newDay;
				minute = minute < 10 && minute.length < 2 ? "0" + minute : minute;
				second = second < 10 && second.length < 2 ? "0" + second : second;

				return arr.length > 3 ?
					`${newYear}-${newMonth}-${newDay} ${hour}:${minute}:${second}` :
					`${newYear}-${newMonth}-${newDay}`;
			},
			dateRegexFun(date, obj) {
				for (let key in obj) {
					if (date.match(obj[key])) return date.match(obj[key]);
				}
			}
		},
		created() {
			this.day = utils.getNowFormatDate().substring(0, 7);
			this.homePage(this.day);
			this.versions = this.$store.getters.getVersions;
		},
		mounted() {
			var $this = this;
			utils.timing(function() {
				$this.homePage($this.day);
			}, 10000);
			let prevBtn = document.querySelector(
				".el-calendar__button-group .el-button-group>button:nth-child(1)"
			);
			prevBtn.addEventListener("click", e => {
				this.day = this.getPreMonth(this.day + "-01").substring(0, 7);
				this.homePage(this.day);
			});

			//点击下一个月
			let nextBtn = document.querySelector(
				".el-calendar__button-group .el-button-group>button:nth-child(3)"
			);
			nextBtn.addEventListener("click", () => {
				console.log("这是下个月")
				this.day = this.getNextMonth(this.day + "-01").substring(0, 7);
				this.homePage(this.day);
			});

			//点击今天
			let todayBtn = document.querySelector(
				".el-calendar__button-group .el-button-group>button:nth-child(2)"
			);
			todayBtn.addEventListener("click", () => {
				console.log("这是今天")
				this.day = utils.getNowFormatDate().substring(0, 7);
				this.homePage(this.day);
			});
		}
	}
</script>

<style>
	.table2 .title {
		font-size: 22px;
		margin: 20px 20px;
	}

	.table2 .statusList {
		display: flex;
		justify-content: space-between;
		padding-top: 30px;

	}

	.table2 .statusList2 {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.table2 .statusList .mes {
		width: 30%;
		text-align: center;
		font-size: 32px;
		font-weight: bold;
	}

	.table2 .statusList2 .mes {
		width: 30%;
		text-align: center;
		font-size: 15px;
	}

	.table2 .el-calendar-table .el-calendar-day {
		height: 30px;
		font-size: 12px;
		padding: 2px;
		text-align: center;
	}
	.table3 .el-calendar-table .el-calendar-day {
		height: 50px;
		font-size: 15px;
		padding: 2px;
		text-align: center;
	}

	.table2 .el-calendar__header {
		font-size: 12px;
		padding: 5px 10px;
	}

	.table2 .el-calendar__body {
		padding: 5px 10px;
	}

	.table2 .el-calendar-table thead th {
		font-size: 12px;
		padding: 5px 0;
	}

	.table2 .dataBox {
		width: 100%;
		height: 100%;
		overflow: hidden;
		display: flex;
	}

	.table2 .dataBox .icon {
		width: calc(100% - 300px);
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		padding: 20px 0;
	}

	.table2 .dataBox .icon div {
		font-size: 13px;
		padding-top: 70px;
		width: 50%;
		margin: 20px 0 0 0;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/pages/homepage/home.vue